import { REMOVE_DEVICES, SET_DEVICE_DATA, SET_TOTAL_DEVICES, SET_DEVICE_FILTER_DATA, SET_DEVICE_PERCENTAGE, SET_AVAILABLE_SERIAL_NUMBERS, SET_TOTAL_FILTERED_DEVICES, SET_DEVICE_COUNT, SET_DEVICE_TYPE_COUNT } from "../types";

export const setDevicesData = (data) => ({
    type: SET_DEVICE_DATA,
    payload: data,
})

export const setDevicePercentage = (data) => ({
    type: SET_DEVICE_PERCENTAGE,
    payload: data,
})

export const setDeviceCount = (count) => ({
    type: SET_DEVICE_COUNT,
    payload: count,
})

export const setDeviceTypeCount = (count) => ({
    type: SET_DEVICE_TYPE_COUNT,
    payload: count,
})

export const setDevicesFilterData = (data) => ({
    type: SET_DEVICE_FILTER_DATA,
    payload: data,
})

export const setTotalDevices = (totalDevices) => ({
    type: SET_TOTAL_DEVICES,
    payload: totalDevices,
});

export const setTotalFilteredDevices = (totalFilteredDevices) => ({
    type: SET_TOTAL_FILTERED_DEVICES,
    payload: totalFilteredDevices,
});


export const removeDevices = () => {
    return {
        type: REMOVE_DEVICES
    }
}

export const setAvailableSerialNumbers = (serialNumbers) => ({
    type: SET_AVAILABLE_SERIAL_NUMBERS,
    payload: serialNumbers,
})
